import ObjectID from 'bson-objectid'
import moment from 'moment'
import state from './state'

const dateFormat = (moment) => {
  return moment.unix()
}

// save a document
export const save = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const date = moment()
    const coll = payload.db
    if (!coll) reject(new Error('Error saving document: doc.db is mandatory'))
    if (!state[coll]) reject(new Error('Error saving document: unknown doc.db'))
    let doc = Object.assign({}, payload)
    delete doc.db
    if (!doc._id) doc._id = ObjectID.generate()
    if (!doc.created) doc.created = dateFormat(date)
    doc.updated = dateFormat(date)
    state[coll].put(doc)
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
}

// remove a document
export const remove = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const coll = payload.db
    const doc = payload
    if (!coll) reject(new Error('Error deleting document: doc.db is mandatory'))
    if (!state[coll]) reject(new Error('Error deleting document: unknown doc.db'))
    if (!doc._id || !doc._rev) reject(new Error('Error removing document: doc._id and doc._rev are mandatory'))
    state[coll].remove(doc)
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
}

export const removeById = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const coll = payload.db
    const id = payload.id
    if (!coll) reject(new Error('Error deleting document: doc.db is mandatory'))
    if (!state[coll]) reject(new Error('Error deleting document: unknown doc.db'))
    if (!id) reject(new Error('Error removing document: doc.id is mandatory'))
    state[coll].get(id).then(doc => {
      state[coll].remove(doc)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  })
}

// save multipe documents in multiple collections
export const bulkDocs = ({ commit }, payload) => {
  const docsByCollection = payload.reduce((colls, doc) => {
    const coll = doc.db
    if (!colls[coll]) colls[coll] = []
    let docCopy = Object.assign({}, doc)
    delete docCopy.db
    colls[coll].push(docCopy)
    return colls
  }, {})
  const bulk = (collection, docs) => new Promise((resolve, reject) => {
    state[collection].bulkDocs(docs)
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
  const bulks = Object.keys(docsByCollection)
    .map(collection => bulk(collection, docsByCollection[collection]))
  return Promise.all(bulks)
}

export const saveLocation = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const line = payload.line
    const pos = payload.pos
    const coords = [pos.coords.longitude, pos.coords.latitude, pos.coords.altitude]
    const ts = pos.timestamp
    state.line.get(line).then(doc => {
      doc.coordinates.push(coords)
      doc.properties.time.push(ts)
      state.line
        .put(doc)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  })
}
